<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import TwConfirmDialog from '../../TwConfirmDialog';

export default {
  name: 'SkistarAccommodationImportStatus',
  components: {
    TwConfirmDialog,
  },
  data() {
    return {
      siteId: undefined,
    };
  },
  computed: {
    ...mapState({
      accommodation: state => state.skistar.accommodation.selected,
      importedAccommodation: state =>
        state.skistar.accommodation.importStatus.importedAccommodation,
      show: state => state.skistar.accommodation.importStatus.show,
      loading: state => state.skistar.accommodation.importStatus.loading,
      updateInProgress: state => state.skistar.accommodation.importStatus.updateInProgress,
      sites: state => state.skistar.sites.items,
      sitesLoading: state => state.skistar.sites.itemsLoading,
      twentyHomePath: state => state.app.twenty.urls.home,
    }),
    ...mapGetters({
      getImportedAccommodationSiteName: 'skistar/getImportedAccommodationSiteName',
    }),
    isSiteChanged() {
      return this.siteId !== this.importedAccommodation.siteId;
    },
  },
  methods: {
    ...mapActions({
      close: 'skistar/closeAccommodationImportStatus',
      changeSiteOnAccommodation: 'skistar/changeSiteOnAccommodation',
    }),
  },
  watch: {
    importedAccommodation: {
      handler() {
        this.siteId = this.importedAccommodation.siteId;
      },
      deep: true,
    },
  },
};
</script>

<template>
  <v-layout>
    <tw-confirm-dialog
      @confirm="changeSiteOnAccommodation(siteId)"
      title="Are you sure?"
      description="This will move the accommodation to the site chosen - continue?"
      ref="changeSiteDialog"
    />
    <v-flex xs12 class="text-xs-right">
      <v-dialog
        v-model="show"
        @input="close"
        width="800"
      >
        <v-card tile>
          <v-layout row>
            <v-flex>
              <v-card-title class="modal-title">
                {{ accommodation.name }}, {{ accommodation.description}}
              </v-card-title>
            </v-flex>
            <v-flex>
              <v-card-actions>
                <v-spacer/>
                <v-btn
                  @click="close"
                  color="red darken-1"
                  flat
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-progress-linear
              v-if="loading"
              indeterminate
            >
            </v-progress-linear>
            <template v-else>
              <v-layout row>
                <v-flex xs1>
                  <v-btn
                    :href="`${twentyHomePath}/production/products/sites/
                    ${importedAccommodation.siteId}/edit`"
                    target="_blank"
                    small
                    fab
                  >
                    <v-icon>launch</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs8 pl-4>
                  <v-text-field
                    :value="getImportedAccommodationSiteName"
                    label="Twenty site"
                  readonly
                />
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs1>
                  <v-btn
                    :href="`${twentyHomePath}/production/products/accommodations/
                    ${importedAccommodation.accommodationId}/edit`"
                    target="_blank"
                    small
                    fab
                  >
                    <v-icon>launch</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs8 pl-4>
                  <v-text-field
                    :value="importedAccommodation.accommodation.name"
                    label="Twenty accommodation"
                    readonly
                  />
                </v-flex>
              </v-layout>
              <v-divider />
              <v-layout row>
                <v-flex xs8 offset-xs1 pl-4 pt-4>
                  <v-autocomplete
                    v-model="siteId"
                    :items="sites"
                    :loading="sitesLoading"
                    :disabled="sitesLoading"
                    label="Change Twenty site"
                    item-text="name"
                    item-value="id"
                  />
                </v-flex>
                <v-flex xs3 pl-4 pt-4>
                  <v-btn
                    @click="$refs.changeSiteDialog.open"
                    :disabled="!isSiteChanged"
                    :loading="updateInProgress"
                    color="primary"
                  >
                    Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </template>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<style scoped lang="scss">
  @import '../../../assets/scss/variables';

  .modal-title {
    font-size: $font-size-md;
  }
</style>



// WEBPACK FOOTER //
// src/components/ski/skistar/SkistarAccommodationImportStatus.vue